import { createFileRoute } from "@tanstack/react-router";

import {
  BlogListing,
  buildListingHead,
  pageCount,
  pageSlice,
} from "../components/blog/BlogListing";
import { BlogEditorial } from "../components/blog/BlogEditorial";
import { posts } from "../content/blog";
import { PUBLISHER_NODE } from "../lib/blog-seo";
import { SITE_URL } from "../lib/site";

export const BLOG_TITLE = "Блог HAY.agency — SEO, реклама, сайты, CRM и e-commerce";
export const BLOG_DESCRIPTION =
  "Практические статьи и исследования команды HAY.agency о SEO, Яндекс Директе, продвижении в Картах и 2ГИС, разработке сайтов, e-commerce, CRM и автоматизации бизнеса.";
export const BLOG_H1 = "Блог";
export const BLOG_INTRO =
  "Практические статьи HAY.agency о SEO, рекламе, разработке сайтов, CRM, e-commerce и развитии бизнеса.";

export const blogGraphNode = {
  "@type": "Blog",
  "@id": `${SITE_URL}/blog#blog`,
  url: `${SITE_URL}/blog`,
  name: BLOG_TITLE,
  description: BLOG_DESCRIPTION,
  inLanguage: "ru-RU",
  publisher: PUBLISHER_NODE,
};

export const Route = createFileRoute("/blog/")({
  head: () =>
    buildListingHead({
      title: BLOG_TITLE,
      description: BLOG_DESCRIPTION,
      path: "/blog",
      basePath: "/blog",
      page: 1,
      totalPages: pageCount(posts.length),
      items: pageSlice(posts, 1),
      breadcrumbs: [
        ["Главная", "/"],
        ["Блог", "/blog"],
      ],
      extraGraph: [blogGraphNode],
    }),
  component: BlogIndex,
});

function BlogIndex() {
  const totalPages = pageCount(posts.length);

  return (
    <BlogListing
      h1={BLOG_H1}
      intro={BLOG_INTRO}
      items={pageSlice(posts, 1)}
      page={1}
      totalPages={totalPages}
      basePath="/blog"
      breadcrumbCurrent="Блог"
      editorial={<BlogEditorial />}
    />
  );
}
